import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PaymentAPI } from "../../api/PaymentAPI";
import { ProductAPI } from "../../api/ProductAPI";
import { SubscriptionAPI } from "../../api/SubscriptionAPI";
import PopUpAlert from '../../component/PopUpAlert';
import Billing from "./Billing";
import SubscriptionItem from "./SubscriptionItem";
import AddCardDetails from "./AddCardDetails";
import { Box, Button, Tab, Tabs } from "@mui/material";
import { useNavigate } from "react-router";
import PaymentHistoryTable from "./PaymentHistoryTable";
import PayAsYouGoItem from "./PayAsYouGoItem";
import SecondLoader from "../../component/SecondLoader";
import { isClubOwner, isClubStaff, isCoach, isUser } from "../../util/UserRoles";
import OnlinePayment from "../payout-management/OnlinePayment";
import OfflinePayment from "../payout-management/OfflinePayment";


const PaymentInfo = () => {
  document.title = "Paymnent Info";
  const userInfo = useSelector((store) => store.user.userInfo);
  const selectedClub = useSelector((store) => store.user.selectedClub);
  const navigate = useNavigate();
  const [message, setMessage] = useState({ type: '', content: '' });
  const [stripePromise, setStripePromise] = useState(null);
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const [defaultCard, setDefaultCard] = useState("");
  const [pageData, setPageData] = useState({
    pageSize: 5,
    lastPaymentId: ''
  });

  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
  });
  const [data, setData] = useState({
    productDetails: null,
    paymentMethods: [],
    invoices: [],
    paymentHistories: []
  })
  const [refresh, setRefresh] = useState(false);
  const [value, setValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setValue(newValue)

  }
  const setPagination = (key, result) => {
    setPageData((prev) => ({
      ...prev,
      [key]: result
    }))
  };

  const setApiData = (key, result) => {
    setData((prev) => ({
      ...prev,
      [key]: result
    }))
  };

  const startLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: true
    }))
  };

  const finishLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: false
    }))
  };

  useEffect(() => {
    if (userInfo?.userId) {
      getPublishKey();
      fetchAllProducts();
      getInvoices();
    }
  }, [userInfo?.userId]);

  useEffect(() => {
    if (userInfo?.userId) {
      const userClubInfo = {
        userId: userInfo?.userId,
        clubId: selectedClub?.clubId,
      };
      fetchPaymentByCustomer(userClubInfo);
      fetchDefaultCardByCustomer(userClubInfo);
      if (isUser(userInfo) || isCoach(userInfo)) {
        fetchSubscriptionForUser();
      }
    }
    setRefresh(false);
  }, [userInfo?.userId, refresh]);

  const fetchDefaultCardByCustomer = async (userClubInfo) => {
    try {
      const res = await PaymentAPI.getPaymentDefaultCard(
        userClubInfo?.userId,
        userClubInfo?.clubId
      );
      setDefaultCard(res?.Data);
    } catch (error) {

    }
  };
  const fetchPaymentByCustomer = async (userClubInfo) => {
    try {
      startLoading("loading2");
      const res = await PaymentAPI.fetchAllPaymentMethods(
        userClubInfo?.userId,
        userClubInfo?.clubId
      );
      setApiData("paymentMethods", res.Data)
      finishLoading("loading2");
    } catch (error) {
      finishLoading("loading2");
    }
  };

  const getPublishKey = async () => {
    const [publishKey, connectedId] = await Promise.allSettled([
      PaymentAPI.getPublishKey(),
      PaymentAPI.getAdminConnectedAccountId({ userId: userInfo.userId, clubId: selectedClub?.clubId })
    ])
    const key = publishKey.status === 'fulfilled' ? publishKey.value?.Data : null;
    if (!key) {
      return;
    }
    if (isClubOwner(userInfo)) {
      setStripePromise(
        loadStripe(key)
      );
    } else {
      const account = connectedId.status === 'fulfilled' ? connectedId.value?.Data : undefined;
      setStripePromise(
        account ? loadStripe(key, { stripeAccount: account }) : loadStripe(key)
      );
    }

  };

  const fetchAllProducts = async () => {
    try {
      startLoading("loading1")
      const allProducts = await ProductAPI.getAllProducts(
        userInfo?.userId,
        selectedClub?.clubId
      );
      setApiData("productDetails", allProducts.Data)
      finishLoading("loading1")
    } catch (error) {
      finishLoading("loading1")
      console.error("error in products", error);
    }
  };

  const fetchSubscriptionForUser = async () => {
    try {
      startLoading("loading1")
      const response = await SubscriptionAPI.getSubscriptionDetail(userInfo?.userId, selectedClub?.clubId);

      setSubscriptionDetails(response.Data);
      finishLoading("loading1")
    } catch (error) {
      finishLoading("loading1")
      console.error("error in fetching subscription", error);
    }
  };

  const getInvoices = async () => {
    try {
      startLoading("loading3");
      const response = await PaymentAPI.getInvoicesForAdmin(userInfo?.userId, selectedClub?.clubId);
      setApiData("invoices", response.Data)
      finishLoading("loading3");
    } catch (error) {
      finishLoading("loading3");
      console.error(error);
    }
  }

  return (
    <div className="payment-info-container">
      <PopUpAlert message={message.content} type={message.type} />
      {(isCoach(userInfo) || isUser(userInfo)) &&
        <>
          <h3 className="subscription_plans_heading">Plans</h3>
          {loadingState.loading1 ?
            <SecondLoader />
            :
            <div data-testid="subscription_plans_conatiner" className={data?.productDetails && data?.productDetails.length == 0 ? "subscription_plans_conatiner active" : "subscription_plans_conatiner"}>
              {(data?.productDetails && data?.productDetails?.length == 0)
                ?
                <>
                  {(isClubOwner(userInfo) ||
                    isClubStaff(userInfo)) &&
                    <div className="user_plan_not_found">
                      <p>At the moment, you have no plan. Please click on Account Setup.</p>
                      <Button variant="contained" onClick={() => navigate('/account-setup')}>Account Setup</Button>
                    </div>}
                  {(isUser(userInfo) || isCoach(userInfo)) &&
                    <div className="user_plan_not_found">
                      <p>This club presently does not have any plans; perhaps the club has not set up their account.</p>
                    </div>
                  }
                </>
                :
                <>

                  {data?.productDetails && data?.productDetails.map((item, index) =>
                    <>
                      {item.planType == 'subscription'
                        ?
                        <SubscriptionItem
                          setMessage={setMessage}
                          product={item}
                          subscriptionInfo={subscriptionDetails}
                          key={index}
                          finishLoading={finishLoading}
                          startLoading={startLoading}
                        />
                        :
                        <PayAsYouGoItem
                          setRefresh={setRefresh}
                          finishLoading={finishLoading}
                          startLoading={startLoading}
                          setMessage={setMessage}
                          product={item}
                          subscriptionInfo={subscriptionDetails}
                          key={index}
                        />}
                    </>

                  )}
                </>}
            </div>}
        </>}
      <div className="pay-card-details-heading">Payment Methods</div>
      {loadingState.loading2 ?
        <SecondLoader />
        :
        <Elements stripe={stripePromise}>
          <AddCardDetails startLoading={startLoading} finishLoading={finishLoading}
            paymentMethods={data?.paymentMethods} setRefresh={setRefresh} defaultCard={defaultCard} />
        </Elements>}

      {/* {(isClubOwner(userInfo) || isCoach(userInfo))&& */}
      <>
        <h1 style={{ margin: 0 }}>Invoices</h1>
        {loadingState?.loading3 ? <SecondLoader /> : <Billing invoices={data?.invoices} />}
      </>
      {/* } */}



      {isUser(userInfo) &&
        <>
          <h1>Payment History</h1>

         
              <Box sx={{ borderBottom: 1, borderColor: 'divider',margin:0 }}>
                <Tabs className='money_movement-tabs' value={value} onChange={handleTabChange} aria-label="basic tabs example">
                  <Tab className='money-move-tab'
                    sx={{ fontWeight: 600 }} label="Online Payments" />
                  <Tab
                    className='money-move-tab'
                    sx={{ fontWeight: 600 }} label="Offline Paymnets" />

                </Tabs>
              </Box>
           
    
            {value == 0 && <OnlinePayment />}
            {value == 1 && <OfflinePayment />}

         
        </>
      }
    </div>
  );
};

export default PaymentInfo;